import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    eliminationSettingFind(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/find`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    eliminationSettingSave(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/save`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    eliminationSettingView(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/view/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    eliminationSettingUpdate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/update`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	eliminationSettingDelete(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/delete`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
    eliminationSettingList(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/list`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	eliminationSettingImport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/eliminationsetting/import`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	eliminationSettingImportProceed(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/eliminationsetting/import/proceed`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	eliminationSettingExport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/eliminationsetting/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
}
